import { createSlice } from "@reduxjs/toolkit";
import i18next from "i18next";

const initialState = {  
  language: 'en'
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    switchLanguage: (state, action) => {
      const newLanguage = action.payload;      
      i18next.changeLanguage(newLanguage);
      localStorage.setItem('language', newLanguage);      
      state.language = newLanguage;
    }
  }
})

export const {switchLanguage} = languageSlice.actions;

export const getLanguage = (state) => state.language;

export default languageSlice.reducer;